import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function AdminCuadros() {
  const API = "https://lucianaavalostattoo.com/cuadros_api.php";

  // ================= AUTH =================
  const [autorizado, setAutorizado] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorAuth, setErrorAuth] = useState("");

  useEffect(() => {
    if (localStorage.getItem("admin_cuadros") === "true") {
      setAutorizado(true);
    }
  }, []);

  const handleLogin = () => {
    if (password === "cuadroslu") {
      localStorage.setItem("admin_cuadros", "true");
      setAutorizado(true);
      setErrorAuth("");
    } else {
      setErrorAuth("Contraseña incorrecta");
    }
  };

  // ================= STATE =================
  const [cuadros, setCuadros] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openModal, setOpenModal] = useState(false);
  const [editando, setEditando] = useState(null);

  const [titulo, setTitulo] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [precio, setPrecio] = useState("");
  const [imagen, setImagen] = useState(null);
  const [preview, setPreview] = useState(null);

  // ================= HELPERS =================
  const formatearPrecio = (valor) => {
    const limpio = valor.replace(/\D/g, "");
    return limpio.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const precioNumero = (valor) => {
    return parseFloat(valor.replace(/\./g, "")) || 0;
  };

  // ================= FETCH =================
  const fetchCuadros = async () => {
    try {
      const res = await fetch(`${API}?action=listar`);
      const data = await res.json();
      if (data.ok) setCuadros(data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCuadros();
  }, []);

  // ================= BASE64 =================
  const convertirBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleFile = async (file) => {
    if (!file) return;
    const base64 = await convertirBase64(file);
    setImagen(base64);
    setPreview(base64);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFile(e.dataTransfer.files[0]);
  };

  // ================= CRUD =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    const action = editando ? "actualizar" : "crear";

    const payload = {
      id: editando?.id,
      titulo,
      descripcion,
      precio: precioNumero(precio),
      imagen,
    };

    const res = await fetch(`${API}?action=${action}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (data.ok) {
      fetchCuadros();
      cerrarModal();
    }
  };

  const eliminar = async (id) => {
    if (!window.confirm("¿Eliminar cuadro?")) return;
    await fetch(`${API}?action=eliminar&id=${id}`);
    fetchCuadros();
  };

  // ================= MODAL =================
  const abrirCrear = () => {
    setEditando(null);
    setTitulo("");
    setDescripcion("");
    setPrecio("");
    setImagen(null);
    setPreview(null);
    setOpenModal(true);
  };

  const abrirEditar = (c) => {
    setEditando(c);
    setTitulo(c.titulo);
    setDescripcion(c.descripcion);
    setPrecio(formatearPrecio(c.precio.toString()));
    setPreview(c.imagen);
    setOpenModal(true);
  };

  const cerrarModal = () => setOpenModal(false);

  // ================= LOGIN =================
  if (!autorizado) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f8f3ed] px-4">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white p-8 rounded-3xl shadow-xl w-full max-w-sm"
        >
          <h2 className="text-xl font-serif text-center mb-4">
            Acceso administrador
          </h2>

          {/* INPUT PASSWORD */}
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 pr-12 border rounded-xl focus:outline-none"
            />

            {/* ICONO OJO */}
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600"
            >
              {showPassword ? (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M3 3l18 18M10.58 10.58A3 3 0 0113.42 13.42M9.88 5.09A9.77 9.77 0 0112 5c5 0 9 5 9 7a9.77 9.77 0 01-2.09 3.91M6.53 6.53C4.3 7.74 2.67 9.63 2 12c1 2 4 7 10 7a9.77 9.77 0 003.47-.62" />
                </svg>
              ) : (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              )}
            </button>
          </div>

          <button
            onClick={handleLogin}
            className="w-full bg-black text-white py-3 rounded-xl mt-4"
          >
            Entrar
          </button>

          {errorAuth && (
            <p className="text-red-500 text-sm mt-3 text-center">
              {errorAuth}
            </p>
          )}
        </motion.div>
      </div>
    );
  }

  // ================= ADMIN =================
  return (
    <div className="min-h-screen pt-[90px] px-4 bg-gradient-to-b from-[#fffdf9] via-[#fef9f3] to-[#f8f3ed]">
      <div className="max-w-6xl mx-auto">

        {/* HEADER */}
        <div className="flex justify-between items-center mb-10">
          <h2 className="text-3xl font-serif text-[#2c2c2c]">
            Administración de Cuadros
          </h2>

          <button
            onClick={abrirCrear}
            className="bg-black text-white p-3 rounded-full hover:scale-110 transition"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 5v14M5 12h14" />
            </svg>
          </button>
        </div>

        {/* LISTA */}
        {loading ? (
          <p className="text-center text-gray-500">Cargando...</p>
        ) : cuadros.length === 0 ? (
          <p className="text-center italic text-gray-500">
            No hay cuadros todavía
          </p>
        ) : (
          <div className="grid md:grid-cols-3 gap-8">
            {cuadros.map((c) => (
              <motion.div
                key={c.id}
                whileHover={{ scale: 1.02 }}
                className="bg-white rounded-3xl shadow p-5"
              >
                <div className="h-52 flex items-center justify-center bg-gray-50 rounded-xl mb-4">
                  <img src={c.imagen} className="max-h-full object-contain" />
                </div>

                <h3 className="font-serif text-lg">{c.titulo}</h3>
                <p className="text-sm text-gray-500">{c.descripcion}</p>
                <p className="font-semibold mt-2">
                  ${formatearPrecio(c.precio.toString())}
                </p>

                <div className="flex gap-3 mt-4">
                  <button
                    onClick={() => abrirEditar(c)}
                    className="flex-1 border border-black py-2 rounded-xl hover:bg-black hover:text-white transition"
                  >
                    Editar
                  </button>

                  <button
                    onClick={() => eliminar(c.id)}
                    className="flex-1 border border-black py-2 rounded-xl hover:bg-black hover:text-white transition"
                  >
                    Eliminar
                  </button>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>

      {/* MODAL */}
      <AnimatePresence>
        {openModal && (
          <motion.div
            className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.form
              onSubmit={handleSubmit}
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              className="bg-white p-8 rounded-3xl w-full max-w-lg space-y-4"
            >
              <h2 className="text-xl font-serif text-center">
                {editando ? "Editar Cuadro" : "Nuevo Cuadro"}
              </h2>

              <input
                value={titulo}
                onChange={(e) => setTitulo(e.target.value)}
                placeholder="Título"
                className="w-full p-3 border rounded-xl"
              />

              <textarea
                value={descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
                placeholder="Descripción"
                className="w-full p-3 border rounded-xl"
              />

              <input
                value={precio}
                onChange={(e) => setPrecio(formatearPrecio(e.target.value))}
                placeholder="Precio"
                className="w-full p-3 border rounded-xl"
              />

              <label
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
                className="flex flex-col items-center border border-dashed border-black rounded-2xl p-6 cursor-pointer"
              >
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleFile(e.target.files[0])}
                  className="hidden"
                />

                {!preview ? (
                  <p className="text-sm text-gray-500">
                    Subir imagen o arrastrar
                  </p>
                ) : (
                  <img src={preview} className="max-h-40 object-contain" />
                )}
              </label>

              <div className="flex gap-3">
                <button className="flex-1 bg-black text-white py-3 rounded-xl">
                  Guardar
                </button>

                <button
                  type="button"
                  onClick={cerrarModal}
                  className="flex-1 border border-black py-3 rounded-xl"
                >
                  Cancelar
                </button>
              </div>
            </motion.form>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}